import styles from './BundlesEmptyState.module.css'
import {
  EmptyState,
  EmptyStateDescription,
  EmptyStateIllustration,
  EmptyStateTitle,
} from '@/components/EmptyState'
import { type BundleArchivedFilterOptions } from '@/features/admin/bundle/BundleStore'
import { byDesign } from '@/infra/design'
import imgEmptyUrl from '@/assets/misc/img_empty.svg'
import LookingEmptyIllustration from '@/components/SpotIllustration/LookingEmptyIllustration'

export interface BundlesEmptyStateProps {
  /**
   * `null` when all workspaces are shown.
   */
  currentWorkspaceName: string | null
  currentArchivedStatusTab: BundleArchivedFilterOptions
}

export function BundlesEmptyState({
  currentWorkspaceName,
  currentArchivedStatusTab,
}: BundlesEmptyStateProps) {
  const archivedStatus = (
    <span className={styles.boldText}>
      {mapBundleArchivedFilterOptionsToText(currentArchivedStatusTab)}
    </span>
  )
  return (
    <div className={styles.root}>
      <EmptyState size="sm" narrow>
        <EmptyStateIllustration
          src={imgEmptyUrl}
          illustration={byDesign(undefined, LookingEmptyIllustration)}
        />
        <EmptyStateTitle>No bundles to display</EmptyStateTitle>
        <EmptyStateDescription>
          {currentWorkspaceName === null ? (
            <>There are currently no {archivedStatus} bundles.</>
          ) : (
            <>
              There are currently no {archivedStatus} bundles in the{' '}
              <span className={styles.boldText}>{currentWorkspaceName}</span>{' '}
              workspace.
            </>
          )}
        </EmptyStateDescription>
      </EmptyState>
    </div>
  )
}

function mapBundleArchivedFilterOptionsToText(
  currentArchivedStatusTab: BundleArchivedFilterOptions,
) {
  switch (currentArchivedStatusTab) {
    case 'Active':
      return 'active'
    case 'Archived':
      return 'archived'
  }
}
